import { useFirebaseQuery } from '../hooks/firebaseHooks'
import { useOrganization } from '../context/OrganizationContext'
import { COLLECTIONS, PATHS } from '../utils/shared/constants'
import { DataTable } from '../components/DataTable'
import { useText } from '../context/TextContext'
import { Customer } from '../models/shared/Customer'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import { Dropdown } from 'react-bootstrap'
import { ThreeDotsMenu } from '../components/ThreeDotsMenu'
import { AdvancedDropdownItem } from '../components/AdvancedDropdownItem'
import { useSaveToast } from '../context/SaveToastContext'
import { useFirestore } from 'reactfire'
import { doc, setDoc, where } from 'firebase/firestore'
import CustomerName from '../components/CustomerName'
import AccountingSystemBadge from '../components/AccountingSystemBadge'

export default function CustomersPage() {
    const text = useText();
    const { orgId, organization } = useOrganization()
    const [customers] = useFirebaseQuery<Customer>(`${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.CUSTOMERS}`, where('status', '==', 'active'));
    const { startSaving, markSaved } = useSaveToast();
    const firestore = useFirestore();

    const handleDelete = async (customerId: string) => {
        const saveId = startSaving();

        const customerUpdate: Partial<Customer> = {
            status: 'archived'
        }

        await setDoc(doc(firestore, `${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.CUSTOMERS}/${customerId}`), customerUpdate, { merge: true });

        markSaved(saveId);
    }

    return (
        <>
            <PageHeader title={text.customers} actions={[{ text: text.newCustomer, icon: 'bi-plus', link: PATHS.CUSTOMERS_EDIT }]} />

            <DataTable className='mt-4' data={customers}
                columns={[
                    {
                        label: text.name, render: (customer) => <Link to={`${PATHS.CUSTOMERS}/${customer.id}`}>
                            <div className='d-flex align-items-center gap-2'>
                                <CustomerName customer={customer} />
                                <AccountingSystemBadge customer={customer} accountingType={organization.integrations?.accountingType} />
                            </div>
                        </Link>
                    },
                    {
                        label: text.actions,
                        align: 'right',
                        render: (customer) => {

                            return <ThreeDotsMenu>
                                <AdvancedDropdownItem icon='bi-eye' text={text.view} link={`${PATHS.CUSTOMERS}/${customer.id}`} />
                                <AdvancedDropdownItem icon='bi-pencil' text={text.edit} link={`${PATHS.CUSTOMERS_EDIT}/${customer.id}`} />
                                <Dropdown.Divider />
                                <AdvancedDropdownItem onClick={() => handleDelete(customer.id || '')} icon='bi-trash' text={text.archive} />
                            </ThreeDotsMenu>

                        }
                    }
                ]}
            />
        </>
    )
}
